import React, { Component } from 'react';
import http from '../api';

import x_img from '../../../resources/img/x.svg';
import CardIcon from '../common/CardIcon';

import * as StringUtil from '../utils/StringUtil';

// var calc_payment = false;
// var fromExpect = false;
var pf = null;
var isPayLinkClick = false;
class PersonalPaymentPopup extends Component {

constructor(props) {
    super(props);
    this.state = {
        userPersonalOrderPrice : {},
        payLinkPreData : {},

        order_type : "02003"
    }
}

componentDidMount() {
    // this.loadUserPersonalOrderPrice();
    this.getdUserPersonalOrderPrice();
}

componentDidUpdate() {
    // PG창 호출 이벤트
    if(isPayLinkClick) {
        isPayLinkClick = false;

        console.log(pf);
        pf = document.payForm;
    
        // var fileName = "https://apitest.payjoa.co.kr/pay/link"; //개발서버
        var fileName = "https://api.kiwoompay.co.kr/pay/link"; //운영서버
        var PAYJOA = window.open("", "PAYJOA", "width=468,height=750");
        
        pf.target = "PAYJOA";
        pf.action = fileName;
        pf.method = "post";
        pf.submit();
    }
}

getdUserPersonalOrderPrice() {
    http.get(`/rest/shop/selectUserPersonalOrderPrice`).then(res => {
        if (!res.data) {
            alert("등록된 결제 정보가 없습니다.");
            window.location.href = "/";         
        } else {
            this.setState({userPersonalOrderPrice : res.data});
        }
    })
    .catch(error => {
        console.error (error);
    })
}

loadUserPersonalOrderPrice() {
    http.post(`/rest/shop/loadUserPersonalOrderPrice`).then(res => {
        if (res.data.result == false) {
            alert(res.data.result_msg);            
        } else {
            isPayLinkClick = true;
            this.setState({payLinkPreData : res.data.data});
        }
    })
    .catch(error => {
        console.error (error);
    })
}


 render() {
    const { isPopup, isClose, onClose } = this.props; // 팝업 여부 prop 전달
    return (
        <>
            <div id="personal-payment-page" className={isPopup ? 'popup-mode' : ''}>
                {/* <div className="payment-header">
                <span className="back-arrow">←</span>
                <span className="payment-title">결제하기</span>
                <span className="badge">샤샤</span>
                </div> */}
                {/* 닫기 버튼 */}
                {isClose && (
                <button className="close-button" onClick={onClose}>
                    <img src={x_img} alt="닫기 버튼" />
                </button>
                )}

                <div className="payment-content">
                <div className="order-title">
                    <CardIcon/>
                    <span style={{ verticalAlign: 'middle' }}>주문하기</span>
                </div>

                <div className="order-box">
                    <div className="product-title">{this.state.userPersonalOrderPrice ? this.state.userPersonalOrderPrice.title : ""}</div>

                    <div className="order-row">
                    <span className="title">상품금액</span>
                    <span>{StringUtil.numberComma(this.state.userPersonalOrderPrice.price ? this.state.userPersonalOrderPrice.price : 0)}원</span>
                    </div>
                    <div className="order-row">
                    <span className="title">부가세</span>
                    <span>{StringUtil.numberComma(this.state.userPersonalOrderPrice.tax_price ? this.state.userPersonalOrderPrice.tax_price : 0)}원</span>
                    </div>
                    <div className="order-row total">
                    <strong className="title">최종 결제 금액</strong>
                    <strong>{StringUtil.numberComma(this.state.userPersonalOrderPrice.payment_price ? this.state.userPersonalOrderPrice.payment_price : 0)}원</strong>
                    </div>
                </div>

                <button className="pay-button" onClick={() => this.loadUserPersonalOrderPrice()}>결제하기</button>
                </div>
            </div>
        
            <form name="payForm" style={{display:"none"}} accept-charset="euc-kr">
                <table style={{width:"100%",border:"1px",cellspacing:"0", cellpadding:"0"}}>
                    <colgroup>
                        <col width="160px" />
                        <col width="*" />
                    </colgroup>
                    <tr>
                        <td></td>
                        <td>
                            {/* <input type="button" value="결제하기" onClick={this.payLink} style={{width:"63", height:"25"}}/> */}
                        </td>
                    </tr>
                </table>
                <br/>
                <br/>

                <table style={{width:"100%",border:"1px",cellspacing:0,cellpadding:0}}>
                    <colgroup>
                        <col width="160px" />
                        <col width="180px" />
                        <col width="*" />
                    </colgroup>
                    <tr> 
                        <td colspan="3"><b>----------공통항목(필수)</b></td>
                    </tr>
                    <tr> 
                        <td><b>파라미터</b></td>
                        <td><b>값</b></td>
                        <td><b>설명</b></td>
                    </tr>
                    <tr> 
                        <td>USER_SEQ</td>
                        <td><input type="text" name="RESERVEDINDEX1" value={this.state.payLinkPreData.USER_SEQ}/></td>
                        <td>사용자 일련번호</td>
                    </tr>
                    <tr> 
                        <td>SHOP_NO</td>
                        <td><input type="text" name="RESERVEDINDEX2" value={this.state.payLinkPreData.SHOP_NO}/></td>
                        <td>쇼핑몰 번호</td>
                    </tr>
                    <tr> 
                        <td>STD_YM</td>
                        <td><input type="text" name="STD_YM" value={this.state.payLinkPreData.STD_YM}/></td>
                        <td>기준 년월</td>
                    </tr>
                    <tr> 
                        <td colspan="3"><b>----------고정항목----------</b></td>
                    </tr>
                    <tr> 
                        <td>TYPE</td>
                        <td><input type="text" name="TYPE" value={/Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? "M" : "P"}/></td>
                        <td>결제방식</td>
                    </tr>
                    <tr> 
                        <td>PAYMETHOD</td>
                        <td><input type="text" name="PAYMETHOD" value={this.state.order_type == "02002" ? "BANK" : "CARD"}/></td>
                        <td>결제수단</td>
                    </tr>
                    <tr> 
                        <td>CPID</td>
                        <td>
                            {/* 개발 : <input type="text" name="CPID" value="CTS10544"/> */}
                            <input type="text" name="CPID" value="CIC11445"/>
                        </td>
                        <td>상점아이디</td>
                    </tr>
                    <tr> 
                        <td>PRODUCTTYPE</td>
                        <td>
                            {/* <input type="text" name="PRODUCTTYPE" value="1"/> */}
                            <input type="text" name="PRODUCTTYPE" value="2"/>
                        </td>
                        <td>상품구분(1: 디지털, 2: 실물)</td>
                    </tr>
                    <tr> 
                        <td colspan="3"><b>----------변동항목(DB에서 조회)----------</b></td>
                    </tr>
                    <tr> 
                        <td>ORDERNO</td>
                        <td><input type="text" name="ORDERNO" value={this.state.payLinkPreData.ORDERNO}/></td>
                        <td>주문번호</td>
                    </tr>
                    <tr> 
                        <td>AMOUNT</td>
                        <td><input type="text" name="AMOUNT" value={this.state.payLinkPreData.AMOUNT}/></td>
                        {/* <td><input type="text" name="AMOUNT" value="1000"/></td> */}
                        <td>결제금액</td>
                    </tr>
                    <tr> 
                        <td>PRODUCTNAME</td>
                        {/* <td><input type="text" name="PRODUCTNAME" value={this.state.payLinkPreData.PRODUCT_NAME}/></td> */}
                        <td><input type="text" name="PRODUCTNAME" value={
                            this.state.payLinkPreData.PRODUCT_NAME
                        }/></td>
                        <td>상품명</td>
                    </tr>
                    <tr> 
                        <td>PRODUCTCODE</td>
                        <td><input type="text" name="PRODUCTCODE" value={this.state.payLinkPreData.PRODUCT_NO}/></td>
                        <td>상품코드</td>
                    </tr>
                    <tr> 
                        <td>USERID</td>
                        <td><input type="text" name="USERID" value={this.state.payLinkPreData.USERID}/></td>
                        <td>고객 ID</td>
                    </tr>
                    <tr> 
                        <td>EMAIL</td>
                        <td><input type="text" name="EMAIL" value={this.state.payLinkPreData.EMAIL}/></td>
                        <td>고객 이메일</td>
                    </tr>
                    <tr> 
                        <td>USERNAME</td>
                        <td><input type="text" name="USERNAME" value={this.state.payLinkPreData.USERNAME}/></td>
                        <td>고객명</td>
                    </tr>
                    <tr> 
                        <td colspan="3"><b>----------변동항목(선택)----------</b></td>
                    </tr>
                    <tr> 
                        <td>RESERVEDSTRING</td>
                        <td><input type="text" name="RESERVEDSTRING" value={this.state.payLinkPreData.PAYMENT_AMOUNT_SEQ}/></td>
                        <td>예약스트링</td>
                    </tr>
                    <tr> 
                        <td>RETURNURL</td>
                        <td><input type="text" name="RETURNURL" value="https://robomd.io/shop/PersonalPaymentCompletePage"/></td>
                        {/* <td><input type="text" name="RETURNURL" value={"http://127.0.0.1:3000/personalPaymentComplete?order_no"+this.state.payLinkPreData.ORDERNO}/></td> */}
                        <td>결제 성공 후, 이동할 URL(새 창)</td>
                    </tr>
                    <tr> 
                        <td>DIRECTRESULTFLAG</td>
                        <td><input type="text" name="DIRECTRESULTFLAG" value=""/></td>
                        <td>페이조아 결제 완료 창 없이 HOMEURL로 바로 이동(Y/N)</td>
                    </tr>
                    <tr> 
                        <td>SET_LOGO</td>
                        <td><input type="text" name="SET_LOGO" value=""/></td>
                        <td>결제 창 하단 상점로고 URL</td>
                    </tr>	
                    <tr> 
                        <td colspan="3"><b>----------웹뷰결제창(필수)</b></td>
                    </tr> 
                    <tr> 
                        <td>HOMEURL</td>
                        <td><input type="text" name="HOMEURL" value="javascript:window.close()"/></td>
                        <td>결제 성공 후, 이동할 URL(결제 창에서 이동)</td>
                    </tr>
                    <tr>
                        <td>CLOSEURL</td>
                        <td><input type="text" name="CLOSEURL" value="javascript:window.close()"/></td>
                        <td>결제 창에서 취소 누를 시 이동할 URL</td>
                    </tr>
                    <tr> 
                        <td>FAILURL</td>
                        <td><input type="text" name="FAILURL" value="javascript:window.close()"/></td>
                        <td>결제실패 후, 확인버튼 입력 시 이동할 URL</td>
                    </tr>
                    <tr>
                        <td>APPURL</td>
                        <td><input type="text" name="APPURL" value=""/></td>
                        <td>인증완료 후 돌아갈 앱의 URL(CARD, CARDK, BANK 필수)</td>
                    </tr>
                    <tr> 
                        <td colspan="3"><b>----------계좌이체(선택)</b></td>
                    </tr>
                    <tr> 
                        <td>USERSSN</td>
                        <td><input type="text" name="USERSSN" value=""/></td>
                        <td>생년월일(YYMMDD)</td>
                    </tr>
                    <tr> 
                        <td>CHECKSSNYN</td>
                        <td><input type="text" name="CHECKSSNYN" value=""/></td>
                        <td>USERSSN사용여부(Y/N)(계좌이체 결제자와 명의자(USERSSN)가 동일한 경우만 결제가능)</td>
                    </tr>
                    {
                        this.state.order_type == "02003" &&
                        <>
                            <tr> 
                                <td>TAXFREECD</td>
                                <td><input type="text" name="TAXFREECD" value="00"/></td>
                                <td>TAXFREECD</td>
                            </tr>
                        </>
                    }
                </table>
            </form>
        </>
    );
  }
}

export default PersonalPaymentPopup;